const footer_bg = () => {

    window.addEventListener("scroll", function() {
        let s_top = document.documentElement.scrollTop;
        let bgElem = document.querySelector(".bg-elem");
        let container = document.querySelector(".footer");
        let offset = container;

        let breakpoint = offset.offsetTop - (container.offsetHeight * 2);


        if(s_top > breakpoint){
            bgElem.style.height = "450px";
            bgElem.style.position = "absolute";
        } else {
            bgElem.style.height = "100px";
            bgElem.style.position = "fixed";
        }
    });
}

export default footer_bg;